'use client';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Section from '@repo/ui/src/components/Section';
import ExpandableContentWithMarkdown from '@components/ExpandableContentWithMarkdown';
import { FlexDirection } from '@repo/ui/src/types';
import dynamic from 'next/dynamic';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import { ToutContentWithMarkdownContainer } from './styles';

const Markdown = dynamic(() => import('@repo/ui/src/components/Markdown'));

interface Props {
  toutContent: any;
  markdownHeading: string;
  markdown: string;
  flexDisplay: FlexDirection;
  forceDivider: boolean;
  expandableTitle: string;
  disclaimerText: string;
  expandableMarkdown: string;
}

export const ToutContentWithMarkdown = ({
  toutContent,
  markdownHeading,
  markdown,
  flexDisplay,
  forceDivider,
  expandableTitle,
  disclaimerText,
  expandableMarkdown,
}: Props) => {
  const smAndDown = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
  return (
    <Section texture gutterX gutterY basePadding>
      <ToutContentWithMarkdownContainer flexDisplay={flexDisplay} smAndDown={smAndDown}>
        <Box className="split">
          <Box className="content">
            <ToutContent
              divider
              headingStyleVariant="h2"
              align="left"
              forceDivider={forceDivider}
              {...toutContent}
            />
          </Box>
          <Box pt={1} className="markdown">
            {markdownHeading && (
              <Typography variant="h6" component="p" gutterBottom>
                {markdownHeading}
              </Typography>
            )}
            {markdown && <Markdown bodySize="xLarge">{markdown}</Markdown>}
          </Box>
        </Box>
        {expandableMarkdown && (
          <Box width="100%" className="markdown">
            <ExpandableContentWithMarkdown
              title={expandableTitle}
              markdown={expandableMarkdown}
              disclaimerText={disclaimerText}
            />
          </Box>
        )}
      </ToutContentWithMarkdownContainer>
    </Section>
  );
};

export default ToutContentWithMarkdown;
